document.addEventListener('DOMContentLoaded', () => {
    const plusButtons = document.querySelectorAll('.plus-button');
    const cards = document.querySelectorAll('.expansible-card');

    function toggleCard(card) {
        const wrappers = document.querySelectorAll('.expansible-carousel-container');
        wrappers.forEach((wrapper) => wrapper.classList.toggle('overflow-hidden'));
        const isExpanded = card.classList.contains('expanded');
        if (isExpanded) {
            card.classList.remove('expanded');
            return;
        }
        document.querySelectorAll('.expansible-card.expanded').forEach(openCard => {
            openCard.classList.remove('expanded');
        });
        card.classList.add('expanded');
    }

    plusButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.stopPropagation();
            const card = button.closest('.expansible-card');
            toggleCard(card);
        });
    });

    // Mouse drag-to-scroll
    const carousels = document.querySelectorAll('.expansible-carousel-container');
    carousels.forEach(carousel => {
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        carousel.addEventListener('mousedown', (e) => {
            isDragging = true;
            carousel._hasDragged = false;
            startX = e.pageX - carousel.offsetLeft;
            scrollLeft = carousel.scrollLeft;
            carousel.classList.add('is-dragging');
        });

        carousel.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const x = e.pageX - carousel.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 5) carousel._hasDragged = true;
            carousel.scrollLeft = scrollLeft - walk;
        });

        const stopDrag = () => {
            isDragging = false;
            carousel.classList.remove('is-dragging');
        };

        carousel.addEventListener('mouseup', stopDrag);
        carousel.addEventListener('mouseleave', stopDrag);
    });

    cards.forEach(card => {
        card.addEventListener('click', () => {
            const carousel = card.closest('.expansible-carousel-container');
            if (carousel?._hasDragged) {
                carousel._hasDragged = false;
                return;
            }
            toggleCard(card);
        });
    });

    const videoSlides = document.querySelectorAll('.default-slide-video')
    videoSlides.forEach(video => {
        video.addEventListener('mouseenter', () => {
            video.play();
          });

          video.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
          });
    })
});

function handleSlide(type, id){
  const carousel = document.querySelector(`.carousel-container--${id}`);
  const scrollOffset = type === 'prev' ? -300 : 300;
  carousel.scrollBy({
    left: scrollOffset,
    behavior: 'smooth'
 });
}

function toggleMutedVideo(blockId){
    const buttonToggle = document.querySelectorAll(`.video-control--${blockId} img`)
    buttonToggle.forEach(buttonImg => buttonImg.classList.toggle('hidden'))

    const video = document.querySelector(`.video--${blockId}`)
    video.muted = !video.muted
    video.play();
}